<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            Denial Report
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container" style="padding-left: 16px;">
                <div style="width: 100%">
                    <ppl-report-filters (filterChanged)="filterChanged($event)" [filterFields]="filterFields" [report]="'denialReport'"></ppl-report-filters>
                </div>
                <div class="chart-info-container">
                    <nz-card id="chart">
                        @if(chartOptions){
                        <apx-chart id='denialReport' [series]="chartOptions.series" [chart]="chartOptions.chart"
                            [dataLabels]="chartOptions.dataLabels" [plotOptions]="chartOptions.plotOptions"
                            [yaxis]="chartOptions.yaxis" [legend]="chartOptions.legend" [fill]="chartOptions.fill"
                            [stroke]="chartOptions.stroke" [tooltip]="chartOptions.tooltip" [title]="chartOptions.title"
                            [xaxis]="chartOptions.xaxis"></apx-chart>
                        }
                    </nz-card>
                    <div class="detailed-data-container">
                        @if(denialReportGridData){
                        <ppl-list-table [disableSort]="true" [disableSearch]="true" [showCustomSearch]="false"
                            [data]="denialReportGridData" [disableSelection]="true" [cols]="cols" [gridTitle]="false"
                            [pagination]="true" [rowsToDisplay]="20" [loadPage]="true" [enableActions]="false"
                            [customDataLoaded]="true" [tableScrollable]="true" [tableWidth]="'35rem'">
                        </ppl-list-table>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>